<template>
  <div>
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <q-tree
      v-else
      :nodes="this.data"
      node-key="label"
      default-expand-all
      no-nodes-label="Не найдено"
      no-results-label="Не найдено"
    >
      <template v-slot:default-header="prop">
        <div class="row items-center">
          <div
            :class="{'text-weight-bold': prop.node.percent === 100}"
            :style="`color: ${prop.node.percent === 100 ? 'green' : '#000'}`"
          >
            {{ prop.node.label }}
          </div>
        </div>
      </template>
    </q-tree>
  </div>
</template>

<script>
import {getEntranceWorkSets} from './services'

export default {
  name: "ResidentialEntranceWorkSets",
  props: ['params'],
  data() {
    return {
      isFetching: false,
      data: [],
    }
  },
  methods: {
    async getData() {
      this.isFetching = true
      const res = await getEntranceWorkSets(this.params)
      this.isFetching = false
      if(!res) return
      this.data = res
    }
  },
  mounted() {
    this.getData()
  }
};
</script>

<style scoped lang="scss"></style>
